import cloneDeep from 'lodash/cloneDeep';
import uuid from 'uuid';
/**
 * @param {import('../logic/types').EcrionFormField} field
 * @param {import('../logic/types').EcrionFormState} state
 */

var getFieldDataSource = function getFieldDataSource(field, state) {
  if (!field) return '';
  if (field.dataSource) return field.dataSource;
  return getFieldDataSource(state.fields[field.parentId], state);
};
/**
 * @param {string} xpath
 * @param {string} parentXpath
 * @returns {{xpath:string, field:string}}
 */


var parseXPath = function parseXPath(xpath) {
  var parentXpath = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  if (!xpath) return null;

  if (parentXpath && xpath.indexOf(parentXpath) == 0) {
    if (xpath.length >= parentXpath.length) return {
      xpath: parentXpath,
      field: xpath.substring(parentXpath.length + 1, xpath.length)
    };
  } else {
    var parts = xpath.split('/');
    return {
      field: parts.pop(),
      xpath: parts.join('/')
    };
  }
};
/**
 * @param {import('../logic/types').EcrionFormState} state
 * @param {import('../logic/types').EcrionFormField} formField
 * @returns {import('./types').Binding} // new created binding
 */


var readFieldBinding = function readFieldBinding(state, formField) {
  var fieldId = formField.id;
  var fieldXpath = formField.xpath;
  var diagramParam = formField.diagramParam;
  var dataSource = getFieldDataSource(formField, state);
  if (!dataSource) return; // nothing can't be done without a data source

  if (!fieldXpath && !diagramParam) return;
  initializeBinding(state);
  var bindings = state.formBindings.bindings;
  var parentFormId = findFirstContextAncestor(state, state.fields[formField.parentId]);

  if (fieldXpath) {
    var parentField = state.fields[formField.parentId];
    var parentXPath = parentField && parentField.xpath;

    var _parseXPath = parseXPath(fieldXpath, parentXPath),
        xpath = _parseXPath.xpath,
        field = _parseXPath.field;

    var bindingId = Object.keys(bindings).find(function (id) {
      return bindings[id].parentFormId === parentFormId && bindings[id].dataSource === dataSource && bindings[id].xpath === xpath;
    });

    if (!bindingId) {
      bindingId = uuid(); // create a new form binding

      state.formBindings.bindings[bindingId] = {
        parentFormId: parentFormId,
        dataSource: dataSource,
        xpath: xpath,
        fields: [],
        params: []
      };
    }

    var binding = state.formBindings.bindings[bindingId];
    binding.fields.push({
      source: field,
      fieldId: fieldId
    });
    state.formBindings.fieldsBindingMap[fieldId] = bindingId;
  }

  if (diagramParam) {
    state.formBindings.bindingParams.push({
      fieldId: fieldId,
      name: diagramParam,
      dataSource: dataSource,
      parentFormId: parentFormId
    });
  }
};
/**
 * @param {import('../logic/types').EcrionFormState} state
 */


function initializeBinding(state) {
  if (!state.formBindings) state.formBindings = {};
  if (!state.formBindings.bindings) state.formBindings.bindings = {};
  if (!state.formBindings.fieldsBindingMap) state.formBindings.fieldsBindingMap = {};
  if (!state.formBindings.bindingParams) state.formBindings.bindingParams = [];
}
/**
 * @param {import('../logic/types').EcrionFormState} state
 * @param {import('../logic/types').EcrionFormField} formField
 */


function findFirstContextAncestor(state, formField) {
  if (!formField) return '';
  var type = formField.type;
  if (type === 'subform' || type === 'form' || type === 'repeating') return formField.id;
  return findFirstContextAncestor(state, state.fields[formField.parentId]);
}
/**
 * @param {string} fieldId
 * @param {import('../logic/types').EcrionFormState} state
 */


var removeFieldFromBinding = function removeFieldFromBinding(fieldId, state) {
  if (!state.formBindings) return;
  if (!state.formBindings.bindings || !state.formBindings.fieldsBindingMap) return;
  var bindingId = state.formBindings.fieldsBindingMap[fieldId];
  var binding = state.formBindings.bindings[bindingId];
  if (!bindingId || !binding) return;
  delete state.formBindings.fieldsBindingMap[fieldId];
  binding.fields = binding.fields.filter(function (f) {
    return f.fieldId !== fieldId;
  });
  if (binding.fields.length == 0) delete state.formBindings.bindings[bindingId];
};
/**
 * @param {{[bindingId:string]:{[fieldId:string]:string}}} info
 * @param {import('../logic/types').EcrionFormState} state
 */


var cloneBindings = function cloneBindings(info, state) {
  if (!state.formBindings) return;
  if (!state.formBindings.bindings || !state.formBindings.fieldsBindingMap) return;
  Object.keys(info).forEach(function (bindingId) {
    var fields = info[bindingId];
    var binding = cloneDeep(state.formBindings.bindings[bindingId]);
    var newBindingId = uuid();
    state.formBindings.bindings[newBindingId] = binding; // update fields in binding

    binding.fields.forEach(function (field) {
      if (fields[field.fieldId]) field.fieldId = fields[field.fieldId];
    });
    Object.keys(fields).forEach(function (fieldId) {
      return state.formBindings.fieldsBindingMap[fields[fieldId]] = newBindingId;
    });
  });
};

export default {
  getFieldDataSource: getFieldDataSource,
  parseXPath: parseXPath,
  readFieldBinding: readFieldBinding,
  removeFieldFromBinding: removeFieldFromBinding,
  cloneBindings: cloneBindings
};